import React from "react";
import { Box, Chip, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

const FuelYourRaceDetailModal = ({ open, onClose, record }) => {
  if (!record) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <div className="d-flex justify-content-between align-center p-3">
        <h3>{record.planName}</h3>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <DialogContent dividers>
        {record.coverimage && (
          <Box sx={{ mb: 2, borderRadius: 1, overflow: "hidden", border: "1px solid #ddd" }}>
            <img src={record.coverimage} alt={record.planName || ""} style={{ width: "100%", maxHeight: 180, objectFit: "cover", display: "block" }} />
          </Box>
        )}

        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1.5 }}>
          {record.profileimg && (
            <Box sx={{ width: 56, height: 56, borderRadius: "50%", overflow: "hidden", border: "1px solid #ddd", flexShrink: 0 }}>
              <img src={record.profileimg} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            </Box>
          )}
          <Box>
            {record.subtitle && <Typography variant="body2" color="text.secondary">{record.subtitle}</Typography>}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
              {record.price !== undefined && <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>${record.price}</Typography>}
              {Boolean(record.discountPercentage) && <Chip label={`${record.discountPercentage}% off`} size="small" color="success" />}
              {record.couponCode && <Chip label={record.couponCode} size="small" variant="outlined" />}
            </Box>
          </Box>
        </Box>

        {record.description && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2">Description</Typography>
            <Typography variant="body2">{record.description}</Typography>
          </Box>
        )}

        {Array.isArray(record.whatYouGet) && record.whatYouGet.length > 0 && (
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 0.5 }}>What You Get</Typography>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {record.whatYouGet.map((point, index) => (
                <li key={index}><Typography variant="body2">{point}</Typography></li>
              ))}
            </ul>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FuelYourRaceDetailModal;